import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AutoTextarea } from "@/components/AutoTextarea";
import { VoiceButton, appendText } from "@/components/VoiceButton";

export const QuickNote = ({ uid, base }) => {
  const { user } = useAuth();
  const key = `lf_quick_${user?.id}_${uid}`;
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(() => localStorage.getItem(key) || "");
  const navigate = useNavigate();
  useEffect(() => { text ? localStorage.setItem(key, text) : localStorage.removeItem(key); }, [key, text]);

  const send = () => {
    navigate(`${base}/notes`, { state: { quickNote: text } });
    setText("");
    setOpen(false);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="quick-note-fab" aria-label="Quick note"
        className="fixed bottom-5 right-5 z-40 flex h-14 items-center gap-1.5 rounded-full bg-[#D97706] px-5 font-medium text-[#0B0D10] shadow-[0_10px_30px_rgba(217,119,6,0.35)] transition-transform active:scale-95 md:hidden"
        style={{ marginBottom: "env(safe-area-inset-bottom)" }}>
        <Plus className="h-5 w-5" />Note{text && <span className="ml-1 h-2 w-2 rounded-full bg-[#0B0D10]" data-testid="quick-note-draft-dot" />}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="quick-note-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Quick note</DialogTitle>
            <DialogDescription>Jot or dictate an idea. It's kept as a draft until you send it to the scribe.</DialogDescription>
          </DialogHeader>
          <AutoTextarea value={text} onChange={(e) => setText(e.target.value)} maxVh={50} autoFocus
            className="min-h-[180px] font-display text-lg leading-relaxed" placeholder="A rumour about the drowned city…" data-testid="quick-note-input" />
          <div className="flex items-center justify-between gap-2">
            <VoiceButton uid={uid} onText={(t) => setText((p) => appendText(p, t))} testid="quick-note-voice-button" />
            <Button onClick={send} disabled={text.trim().length < 3} data-testid="quick-note-send-button"><Wand2 className="mr-1.5 h-4 w-4" />Send to scribe</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
